<template>
  <section class="">
    <h4>{{details.id}} <span v-if="details.title !== ''">{{details.title}}</span></h4>
    <span v-for="(object,index) in details.items" :key="index">
        <nl2br tag="span" :text="object.value" v-if="object.type == `text`"></nl2br>
        <text-form v-if="object.type == `txt`" v-model="details.items[index]" :templateId="templateId"></text-form>
        <input-form v-if="object.type == `single`" v-model="details.items[index]" :templateId="templateId"></input-form>          
        <section-form v-if="object.type == `section`" v-model="details.items[index]" :templateId="templateId" :level="nextlevel"></section-form>        
        <single-form v-if="object.type == `single-select`" v-model="details.items[index]" :templateId="templateId"></single-form> 
        <input-group-form v-if="object.type == `single-group`" v-model="details.items[index]" :templateId="templateId"></input-group-form>
        <multi-form v-if="object.type == `multi-select`" v-model="details.items[index]" :templateId="templateId"></multi-form>        
        <table-form v-if="object.type == `table`" v-model="details.items[index]" :templateId="templateId"></table-form>        
        <dropdown-form v-if="object.type == `dropdown-select`" v-model="details.items[index]" :templateId="templateId"></dropdown-form>        
    </span>
  </section>
</template>
<script>
import TextForm from "./TextForm";
import InputForm from "./InputForm";
import MultiForm from "./MultiForm";
import SingleForm from "./SingleForm";
import InputGroupForm from "./InputGroupForm";
import TableForm from "./TableForm";
import DropdownForm from "./DropdownForm";
export default {
  props: ["item", "level","templateId"],
  components: {
    TextForm,
    MultiForm,
    SingleForm,
    InputForm,
    TableForm,
    DropdownForm,
    InputGroupForm,
    SectionForm: () => import("./SectionForm")
  },
  data() {
    return {
      details: this.item,
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {},
  computed: {
    nextlevel() {
      return this.level + 1;
    }
  }
};
</script>
<style>
</style>